const vehicles = {
  berline: {
    label: "Berline",
    detailedLabel: "Berline (Mercedes E Class or similar)"
  },
  van: {
    label: "Van",
    detailedLabel: "Van (Mercedes V Class or similar)"
  },
  first: {
    label: "First",
    detailedLabel: "Mercedes S Class or similar"
  },
  eco: {
    label: "Eco"
  },
  minibus: {
    label: "Minibus"
  },
  bus: {
    label: "Bus"
  },
  moto: {
    label: "Moto"
  },
  meetngreet: {
    label: "Meet & Greet"
  },
};

function getVehicleDisplayName(vehicleKey) {
  if (!vehicleKey) return '';
  const vehicle = vehicles[vehicleKey.toLowerCase()];
  return vehicle?.detailedLabel || vehicle?.label || vehicleKey;
}

module.exports = {
  vehicles,
  getVehicleDisplayName
};
